var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"frontSection"}},[(
    !_vm.hiddenList.includes(_vm.$route.name)  &&
      !_vm.$route.path.includes('admin-panel')
    )?_c('orgHeader',{staticClass:"width80 margin-auto"}):_vm._e(),_c('router-view'),(    
    !_vm.hiddenList.includes(_vm.$route.name)   &&
      !_vm.$route.path.includes('admin-panel')
      
    )?_c('footerSite'):_vm._e(),(!_vm.$route.path.includes('/supplier-register'))?_c('footerNavigation',{staticClass:"showInMobileFlex"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }